export default {
      id: "icon-bocommercial-usage",
      viewBox: "0 0 121.89 94.31",
      url: __webpack_public_path__ + "icons.svg#icon-bocommercial",
      toString: function () {
        return this.url;
      }
    }